'use strict';

angular.module('ringbaPortal.services').factory('statsService', statsService);

function statsService(
  _,
  $http,
  ngAuthSettings,
  featureFlags,
  utils
) {
  'ngInject';

  const serviceBase = ngAuthSettings.apiServiceBaseUri;

  const DEFAULT_CLOSED_KEY = 'CLOSED';
  const DEFAULT_OPEN_KEY = 'OPEN';

  const fileMap = {
    'Impressions': {
      background: Highcharts.getOptions().colors[1],
      color: '#2e3339'
    },
    'Page Closed': {
      background: Highcharts.getOptions().colors[13]
    },
    'Incoming': {
      background: Highcharts.getOptions().colors[0],
      color: '#2e3339'
    },
    'Connected': {
      background: Highcharts.getOptions().colors[2],
      color: '#2e3339'
    },
    'Completed': {
      background: Highcharts.getOptions().colors[4],
      color: '#2e3339'
    },
    'Converted': {
      background: Highcharts.getOptions().colors[3]
    },
    'No Targets': {
      background: Highcharts.getOptions().colors[11]
    },
    'Error': {
      background: Highcharts.getOptions().colors[8]
    },
    'Blocked': {
      background: Highcharts.getOptions().colors[6],
      color: '#2e3339'
    },
    'No Answer': {
      background: Highcharts.getOptions().colors[5]
    },
    'No Connect': {
      background: Highcharts.getOptions().colors[7]
    },
    'Number Pool Misses': {
      background: Highcharts.getOptions().colors[9]
    },
    'Conversion Amount': {
      background: Highcharts.getOptions().colors[12]
    },
    'Avg Call Length': {
      background: Highcharts.getOptions().colors[10]
    },
    'Payout': {
      background: Highcharts.getOptions().colors[16]
    },
    'Revenue': {
      background: Highcharts.getOptions().colors[15],
      color: '#2e3339'
    },
    'Busy': {
      background: Highcharts.getOptions().colors[17],
      color: '#2e3339'
    },
    'RTB Bids': {
      background: Highcharts.getOptions().colors[18],
      featureFlag: 'rtb'
    },
    'RTB Winning Bids': {
      background: Highcharts.getOptions().colors[19],
      featureFlag: 'rtb'
    },
    'RTB Rejected Requests': {
      background: Highcharts.getOptions().colors[20],
      featureFlag: 'rtb'
    },
    'RTB Rate-Limited Requests': {
      background: Highcharts.getOptions().colors[21],
      featureFlag: 'rtb'
    },
    'default': {
      background: Highcharts.getOptions().colors[22]
    }
  };

  const statsOptions = {
    chart: {
      type: 'areaspline'
    },
    title: {
      text: ''
    },
    xAxis: [{
      crosshair: true,
      type: 'datetime',
      dateTimeLabelFormats: { // don't display the dummy year
        hour: '%l:%M %P'
      },
      id: 'date-axis',
      // Highcharts defaults, which the app theme would otherwise replace.
      lineColor: '#ccd6eb',
      tickColor: '#ccd6eb'
    }],
    credits: {
      enabled: false
    },
    plotOptions: {
      areaspline: {
        fillOpacity: 0.8,
        linecap: 'round'
      },
      series: {
        marker: {
          // Highcharts defaults, which the app theme would otherwise replace.
          lineColor: '#ffffff'
        }
      }
    },
    series: [],
    tooltip: {
      shared: true,
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      borderColor: 'rgba(0, 0, 0, 0.9)',
      style: {
        color: '#fff'
      }
    },
    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      layout: 'horizontal',
    },
  };

  const service = {
    fileMap: fileMap,
    statsOptions: statsOptions,
    stats: [],
    rolledUpStats: [],
    sums: {},
    getRolledUpStats: _getRolledUpStats,
    getStatsSum: _getStatsSum,
    getCallLiveAndCompletedStats: getCallLiveAndCompletedStats,
    getTopStats: getTopStats,
    getTopStatsByHour: getTopStatsByHour,
    getTopRtbStats: getTopRtbStats,
    getTopRtbFailReasonStats: getTopRtbFailReasonStats,
    getCampaignRtbStats: getCampaignRtbStats,
    getCampaignRtbFailReasons: getCampaignRtbFailReasons,
    getCampaignRtbStatsForPublisher: getCampaignRtbStatsForPublisher,
    getCampaignRtbFailReasonsForPublisher: getCampaignRtbFailReasonsForPublisher,
    checkBlockReason: checkBlockReason,
    getPublisherLiveCalls: getPublisherLiveCalls,
    getCampaignStatsForLiveCallTesting: _getCampaignStatsForLiveCallTesting,
    normalizeStats: normalizeStats,
    normalizeStat: normalizeStat
  };

  return service;

  function _getRolledUpStats (accountId, subId, type, past, days) {
    let statPromise;
    if (('undefined' === typeof type) || !type) {
      type = 'account';
    }
    if (('undefined' === typeof past) || !past) {
      past = 0;
    }
    if (('undefined' === typeof days) || !days) {
      days = 7;
    }

    switch (type) {
    case 'account':
      statPromise = _getStats(accountId, past, days);
      break;
    case 'campaign':
      statPromise = _getCampaignStats(accountId, subId, past, days);
      break;
    case 'campaignAffiliate':
      statPromise = _getCampaignAffiliateStats(accountId, subId, past, days);
      break;
    case 'numberpool':
      statPromise = _getNumberPoolStats(accountId, subId, past, days);
      break;
    case 'target':
      statPromise = _getTargetStats(accountId, subId, past, days);
      break;
    }

    return statPromise.then(function(values) {
      return service.stats = values;
    });
  }

  function _getStatsSum(accountId, subId, type, past, days) {
    if (('undefined' === typeof type) || !type) {
      type = 'account';
      subId = accountId;
    }
    if (('undefined' === typeof days) || !days) {
      days = 7;
    }
    if (('undefined' === typeof past) || !past) {
      past = 6;
    }

    if (('undefined' === typeof subId) || !subId) {
      subId = accountId;
    }

    const statPromise = _getStatsSums(accountId, type, subId, past, days);

    return statPromise.then(function(values) {
      const rv = [];
      const days = [];
      
      _.forEach(values, function (day) {

        if (day.length > 0) {
          days.push({
            epoch: day[0].startTime,
            utc_offset: day[0].utc_offset
          });
        } else {
          days.push(0);
        }
      });
      const currentDay = days.length - 1;

      _.forEach(values[currentDay], function(currentRow, index) {
        const isWarn = currentRow.isWarning || false;
        const messageName = currentRow.messageName || 0;
        const messageType = currentRow.messageType || 0;

        if (messageName) {
          const sum = currentRow.sum || 0;
          // We don't add the row if it's a target or warning row that's not a sum
          // We don't add the row if RTB  is disabled and the row belongs to RTB
          if (((type !== 'target' && !isWarn) || sum > 0) &&  (_isRTBEnabled() || (!_isRTBEnabled() && !_isRTB(messageName)))) {
            const record = {
              isWarn: isWarn,
              messageName: messageName,
              sums: [],
              messageType: messageType,
              info: fileMap[messageName]
            };
            _.forEach(values, function(row) {
              record.sums.push(row[index].sum || 0);
            });
            rv.push(record);
          }
        }
      });

      service.sums.days = days;
      service.sums.values = rv;
      return service.sums;
    });
  }

  function getPublisherLiveCalls(accountId,publisherId){
    const url = serviceBase + accountId + '/stats/live/publisher/'+publisherId;
    return $http.get(url).then(function (response){
      return response.data;
    });
  }

  function getCallLiveAndCompletedStats(accountId) {
    //Only load Completed because callers currently only expect metrics for Live and Completed
    const url = serviceBase + accountId + '/stats?messages=Completed';
    return $http.get(url).then(function (response){
      return response.data;
    });
  }

  function getTopStats(accountId, past, days) {
    const url = serviceBase + accountId + '/stats/topByDay';
    past = past || 0;
    days = days || 1;
    const params = { past: past, days: days };
    return $http({
      url: url,
      method: 'GET',
      params: params
    });
  }
  function getTopRtbStats(accountId, past, days) {
    const url = serviceBase + accountId + '/rtb/stats/top';
    past = past || 0;
    days = days || 1;
    const params = { past: past, days: days };
    return $http({
      url: url,
      method: 'GET',
      params: params
    });
  }
  function getTopRtbFailReasonStats(accountId, past, days) {
    const url = serviceBase + accountId + '/rtb/stats/top/failreasons';
    past = past || 0;
    days = days || 1;
    const params = { past: past, days: days };
    return $http({
      url: url,
      method: 'GET',
      params: params
    });
  }

  function getCampaignRtbStats(accountId, data) {
    const url = serviceBase + accountId + '/rtb/stats';
    return $http.post(url, data)
      .then(function (response) {
        return response.data;
      });
  }
  function getCampaignRtbFailReasons(accountId, data) {
    const url = serviceBase + accountId + '/rtb/stats/failreasons';
    return $http.post(url, data)
      .then(function (response) {
        return response.data;
      });
  }

  function getCampaignRtbStatsForPublisher(accountId, data) {
    const url = serviceBase + accountId + '/rtb/stats/publisher';
    return $http.post(url, data)
      .then(function (response) {
        return response.data;
      });
  }
  function getCampaignRtbFailReasonsForPublisher(accountId, data) {
    const url = serviceBase + accountId + '/rtb/stats/publisher/failreasons';
    return $http.post(url, data)
      .then(function (response) {
        return response.data;
      });
  }

  function getTopStatsByHour(accountId, hours) {
    const url = serviceBase + accountId + '/stats/topByHour';
    hours =hours|| 12;
    const params = { hours: hours };
    return $http({
      url: url,
      method: 'GET',
      params: params
    });
  }

  function normalizeStat(objectContainer, stats, statusTranslation) {
    if (objectContainer && stats) {
      if (stats.usageStats) {
        objectContainer.usageStats = stats.usageStats;
      }

      if (stats.status) {
        objectContainer.tStatus = stats.status;
        objectContainer.tStatus.uiStatus = checkBlockReason(objectContainer, statusTranslation);
      }
    }
  }

  function normalizeStats(objectsContainer, stats, caps, statusTranslation) {
    _.forEach(objectsContainer, function (objectContainer) {
      if(stats) {
        normalizeStat(objectContainer, stats[utils.capFirstLetter(objectContainer.id)], statusTranslation);
      }
      if (caps) {
        normalizeCap(objectContainer, caps[utils.capFirstLetter(objectContainer.id)]);
      }
    });
  }

  function normalizeCap(objectContainer, caps) {
    objectContainer.caps = caps;
  }

  function checkBlockReason(objectContainer, statusTranslation) {
    if (statusTranslation) {
      if (objectContainer.tStatus && !objectContainer.tStatus.isAcceptingCalls && statusTranslation[objectContainer.tStatus.blockReason]) {
        return statusTranslation[objectContainer.tStatus.blockReason];
      }
      else {
        return statusTranslation[_getStatusTranslationKey(objectContainer)];
      }
    }
  } 

  function _getStatusTranslationKey(objectContainer) {
    return (objectContainer.enabled ? DEFAULT_OPEN_KEY : DEFAULT_CLOSED_KEY);
  }
  
  function _getStats (accountId, past, days) {
    const url = serviceBase + accountId + '/stats/byDay?past=' + past + '&days=' + days;
    return $http.get(url)
      .then(function (response){
        return response.data.values;
      });
  }  

  // TODO: Use this for live call testing
  function _getCampaignStats (accountId, campaignId, past, days) {
    const url = serviceBase + accountId + '/stats/byDay?type=campaign&id=' +
              campaignId + '&past=' + past + '&days=' + days;
    return $http.get(url)
      .then(function (response){
        return response.data.values;
      });
  }

  function _getNumberPoolStats (accountId, numberPoolId, past, days) {
    const url = serviceBase + accountId + '/stats/byDay?type=numberpool&id=' +
              numberPoolId + '&past=' + past + '&days=' + days;
    return $http.get(url)
      .then(function (response){
        return response.data.values;
      });
  }

  function _getTargetStats (accountId, targetId, past, days) {
    const url = serviceBase + accountId + '/stats/byDay?type=target&id=' +
              targetId + '&past=' + past + '&days=' + days;
    return $http.get(url)
      .then(function (response){
        return response.data.values;
      });
  }

  function _getCampaignAffiliateStats (accountId, campaignId, past, days) {
    const url = serviceBase + accountId + '/stats/byDay?type=campaignAffiliate&id=' +
              campaignId + '&past=' + past + '&days=' + days;
    return $http.get(url)
      .then(function (response){
        return response.data.values;
      });
  }

  function _getStatsSums (accountId, type, id, past, days) {
    const url = serviceBase + accountId + '/stats/sum?days=' + days +
              '&past=' + past + '&type=' + type + '&id=' + id;
    return $http.get(url)
      .then(function (response){
        return response.data.days;
      });
  }

  function _getCampaignStatsForLiveCallTesting(accountId, campaignId) {
    return _getCampaignStats(accountId, campaignId, 0, 1)
      .then(function(stats){
        const summedStats = { errors: 0, warnings: {} };
        for (let i = 0; i < stats.length; i++) {
          const stat = stats[i];
          if (stat.isWarning) {
            if (stat.messageName.toLowerCase() === 'no connect') {
              summedStats.errors += stat.sum;
            } else {
              summedStats.warnings[stat.messageName] = stat.sum;
            }
          } else {
            summedStats[stat.messageName] = stat.sum;
          }
        }
        return summedStats;
      });
  }

  function _isRTB(messageName) {
    return messageName.includes('RTB');
  }

  function _isRTBEnabled() {
    return featureFlags.isOn('rtb');
  }
}
